export default __webpack_public_path__ + "static/image3-8b478a112dae70929a63c4973c9e0024.jpg";